import { pick, isEmpty } from 'lodash';

export default {
  setBreakdown: async ({ commit, dispatch, getters }, payload) => {
    const params = pick(payload, [
      'indicatorId',
      'breakdown',
      'primaryGeoCode',
      'secondaryGeoCode',
      'geoType',
      'dataVersion',
      'args',
      'datasetName',
      'displayRev',
    ]);

    const breakdownSlug = payload.breakdown.slug;

    commit('setLoading', { isLoading: true });

    let res;
    try {
      res = await dispatch('query/fetch', params);
    } catch (err) {
      commit('setLoading', { isLoading: false });
      throw err;
    }

    if (!res) return;

    if (
      params.breakdown.config.geoCodes?.length > 1 &&
      isEmpty(getters.secondaryGeo)
    )
      return;

    commit('setArgs', { args: payload.args });
    commit('breakdownConfigSet', payload.breakdown);

    commit('setLoading', { isLoading: false });
    commit('setAttributes', {
      slug: breakdownSlug,
      attributes: res.attributes,
    });

    commit('setData', { slug: breakdownSlug, data: res.results });

    commit('setPrimaryGeo', { primaryGeo: getters.primaryGeo });

    if (params.secondaryGeoCode) {
      commit('setSecondaryGeo', {
        secondaryGeo: getters.getGeo(params.secondaryGeoCode),
      });
    } else {
      commit('setSecondaryGeo', { secondaryGeo: {} });
    }

    const geoType =
      getters['query/geoType'] ||
      params.geoType ||
      (params.breakdown &&
      params.breakdown.config &&
      params.breakdown.config.geoTypes
        ? params.breakdown.config.geoTypes[0]
        : null);
    commit('setGeoType', { geoType });

    commit('breakdownAugmented', breakdownSlug);
  },

  selectBreakdown: ({ commit }, breakdownSlug) => {
    commit('breakdownSelected', breakdownSlug);
  },

  setGeos: async ({ commit }, payload) => {
    const params = pick(payload, ['geos']);
    commit('setGeos', { geos: params.geos });
  },
};
